import React, {useState, useEffect, Fragment} from 'react';
import Card from 'olive-react-myoneui/lib/Card';
import LiveClassBlock from './LiveClassBlock';
import SampleImage2 from '../../assets/images/sample2.jpg';
import SampleImage3 from '../../assets/images/live_class.png';
import {format} from 'date-fns';
import axios from 'axios';
import {convertTimetoAmPm, getDateInFormat,convertUTCtoLocalTime} from '../../helpers/dateTimeHelper';
// import { _post, EXT, API_URL, headers, authToken } from '../../constants/config';
import { livelistModuleName, nodeUrl,nodeUrlDev } from '../../constants/config';
import { useTranslation } from 'react-i18next';
import { setLangInCache } from '../../utils/helpers';
import moment from 'moment';

function LiveClassGroup({accessToken,uuid,spUid,secret,idp,accountId, timeZone, language='en', allowedProducts=[], className}) {
  const [liveToken,setLiveToken]      = useState(null);
  const [liveEvents, setLiveEvents]   = useState([]);
  const { t, i18n } = useTranslation(livelistModuleName);

  let host                      = window.location.protocol + '//' +window.location.host;
  const startDate = getDateInFormat(new Date, 'yyyy-mm-dd H:i:s');
  const endDate   = startDate;

  const langSet = (lang) => {
    // console.log('lang in live', lang);
    i18n.changeLanguage(lang);
    setLangInCache(lang);
  };

  useEffect(() => {
    langSet(language);
  },[language]);
  
  const getLiveToken = () => {
    setLiveToken(accessToken);
  }

  const liveEventsList = () => {
    if(liveToken){
      const headers = {
        'Content-Type': 'application/json',
        // 'x-access-token' : 'NKNvNTNtNp7wNzNX7uNzNT7v7ZNjN'
        'Authorization': `Bearer ${liveToken}`
      }
      var data = {
        'account_id'    :accountId,
        'reminder_type' : 'live',
        'reminder_status' : 'ongoing'
        // 'start_date'    : startDate,
        // 'end_date'      : endDate,
      }

      const startDate = getDateInFormat(convertUTCtoLocalTime(moment().format('YYYY-MM-DD'), timeZone), 'yyyy-mm-dd');
      //const endDate = getDateInFormat(convertUTCtoLocalTime(moment().add(1, 'days').format('YYYY-MM-DD'), timeZone), 'yyyy-mm-dd');
      const endDate = getDateInFormat(convertUTCtoLocalTime(moment().format('YYYY-MM-DD'), timeZone), 'yyyy-mm-dd');

      let limit = 10;
      axios.get(`${nodeUrl}events/reminder?limit=${limit}&page=1&account_id=${accountId}&us_uuid=${uuid}&reminder_type=live&reminder_status=ongoing&start_date=${startDate}&end_date=${endDate}`,{
        headers
      })
      .then((response) => {
        if(response?.data?.result?.events?.length > 0){
          let filteredEvents = response.data.result.events.filter((event) => {
            return allowedProducts.includes(event.product)
          })
          setLiveEvents(filteredEvents)
        }
      })
      .catch((error) => {
        // Error
        if (error.response) {
          console.log('err1', error.response);
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the 
            // browser and an instance of
            // http.ClientRequest in node.js
            console.log('err2',error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        console.log(error.config);
      });
    }
  }

  /* const liveEventsList = () => {
    axios.get(API_URL+'mykademy/api/v1/events/', {
      // title: "Hello World!",
      // body: "This is a new post.",
      headers: {"Authorization" : `${authToken}`, "Access-Token" : `${accessToken}`}
    })
    .then((response) => {
      let liveData = response?.data?.data?.live_classes;
      if(liveData.length > 0){
        setLiveEvents(liveData);
      }
    });
  }; */

  useEffect(() => {
    getLiveToken()
  }, [accessToken]);

  useEffect(() => {
    liveEventsList();
  },[liveToken]);

  
  function isValidImageUrl(url) { 
    if (!url) {
      return false;  
    } 
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    const lowerCaseUrl = url.toLowerCase();
    return (
      (lowerCaseUrl.startsWith('http://') || lowerCaseUrl.startsWith('https://')) &&
      imageExtensions.some(ext => lowerCaseUrl.endsWith(ext))
    );
  }
  return (
    <React.Fragment>
    {
        liveEvents.length > 0 ? (
        <Card className={`${className || ''} border-0 mb-4`}>
          <Card.Body className="p-0">
                  <Card.Header>
                    <strong>{t('live_class_title')}</strong>
                  </Card.Header>
                  <Card.Body>
                    {/* <LiveClassBlock className="mb-3" courseTitle="Visual Design" courseLogo={SampleImage3} joinButton="Join" copyButton="Copy Link" liveClassTime="Monday, 12 December | 12:00 pm - 1:00 pm" /> */}
                    {
                      
                      liveEvents.map((live) => {
                        console.log('live', live);
                        const days    = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
                        const month   = ["January","February","March","April","May","June","July","August","September","October","November","December"];
                        let startDate = convertUTCtoLocalTime(live.start_date, timeZone);
                        let endDate   = convertUTCtoLocalTime(live.end_date, timeZone);
                        let endHours  = endDate.getHours();
                        endHours      = ("0" + endHours).slice(-2);
                        let endMinutes = endDate.getMinutes();
                        endMinutes     = ("0" + endMinutes).slice(-2);

                        let fullYear    = startDate.getFullYear();
                        let eFullYear   = endDate.getFullYear();

                        let index = startDate.getDay();
                        let day = days[index];
                        let date = startDate.getDate();
                        let eIndex  = endDate.getDay();
                        let eDay    = days[eIndex];
                        let eDate   = endDate.getDate();

                        let hours = startDate.getHours();
                        hours     = ("0" + hours).slice(-2);
                        let minutes = startDate.getMinutes();
                        minutes     = ("0" + minutes).slice(-2);

                        let monthIndex = startDate.getMonth();
                        let monthName = month[monthIndex];
                        let eMonthIndex = endDate.getMonth();
                        let eMonthName  = month[eMonthIndex];
                        let convertedStartTime  = convertTimetoAmPm(hours+':'+minutes);
                        let convertedEndTime    = convertTimetoAmPm(endHours+':'+endMinutes);
                        let event_date = `${day}, ${date} ${monthName} | ${convertedStartTime} - ${convertedEndTime}`;
                        if(date != eDate || monthIndex != eMonthIndex || fullYear != eFullYear){
                          event_date = `${day}, ${date} ${monthName} ${convertedStartTime} - ${eDay}, ${eDate} ${eMonthName} ${convertedEndTime}`;
                        }
                        //let launch_url              = host+'/'+live.launch_url;
                        let launch_url              = live.launch_url;

                        let courseLogo = live.reminder_image;
                        if (!isValidImageUrl(courseLogo)) {
                          courseLogo = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/default-lecture.jpg';
                        }


                        return(
                          <LiveClassBlock 
                            key={live._id} 
                            className="mb-3" 
                            courseTitle={live.reminder_name} 
                            courseLogo={courseLogo} //live.event_image} 
                            joinButton={t('Join')} 
                            joinLink={launch_url} 
                            copyButton={t('copy_link')}
                            liveClassTime={event_date} //"Thursday, 18 September | 09:00 am - 1:00 pm" 
                          />
                        )
                      })
                    }
                    
                  </Card.Body>
                </Card.Body>
          </Card>
        ) : (
          ''
        )
      }
      </React.Fragment>
  );
}

export default React.memo(LiveClassGroup);
